import Home from './pages/Home';
import './App.css';

const App = () => {
	return (
		<>
			<Home />
		</>
	);
};

export default App;
